import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { USER_TYPE } from 'src/app/core/Constants/static';
import { InsuranceList } from 'src/app/core/Models/interfaces/insuranceList';
import { Country, Currency, Regulator } from 'src/app/core/Models/interfaces/responseData';
import { UserDetails, UserProfile } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { CustomValidation } from 'src/app/shared/validators/customValidators';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';

@Component({
    selector: 'app-insurance-listing',
    templateUrl: './insurance-listing.component.html',
    styleUrls: ['./insurance-listing.component.css']
})
export class InsuranceListingComponent implements OnInit {

    showEditPayer: boolean = false;
    addInsurance: boolean = false;
    isLoader: boolean = false;
    public currencyList: Currency[] = [];
    public countryList: Country[] = [];
    public regulatorList: Regulator[] = [];
    filterForm!: FormGroup;
    totalCount!: number;
    page_no: number = 1;
    isViewPayer: boolean = false;
    insuranceList: InsuranceList[] = [];
    page_limit: number = 10;
    sortParams!: string;
    @Output() focus: EventEmitter<boolean> = new EventEmitter<boolean>();
    
    columnSort: any = {
        payerName: {
            sortType: 'ascending',
            clicked: true
        },
        countryName: {
            sortType: 'ascending',
            clicked: true
        },
        regulatoryAuthorityCode: {
            sortType: 'ascending',
            clicked: true
        },
        payerCode: {
            sortType: 'ascending',
            clicked: true
        },
        InsuranceCompany: {
            sortType: 'ascending',
            clicked: true
        },
        payerId: {
            sortType: 'ascending',
            clicked: true
        },
    };
    editPayerId?: number | null;
    showNavigation: boolean = false;
    showDetailView: boolean = false;
    user: UserProfile | null;
    showFilter: boolean = true;
    constructor(
        private provPayerApiService: ProvPayerApiService,
        private toasterandLoader: ToasterService,
        private userService: UserService
    ) {
        this.user = this.userService.getUserInfo();
    }

    ngOnInit(): void {
        // this.showFilterForm();
        this.getMasterLists();
        this.createfilterForm();
    }
    public showFilterForm() {
        if (this.user?.userDetails?.userType === USER_TYPE.payer || this.user?.userDetails?.userType === USER_TYPE.provider) {
            this.showFilter = false;
        } else {
            this.showFilter = true;
        }
    }
    getMasterLists() {
        forkJoin([
            this.provPayerApiService.getCurrencyList(),
            this.provPayerApiService.getCountryList(),
            this.provPayerApiService.getRegulatorList(),
        ]).subscribe({
            next: (responseList) => {
                this.currencyList = responseList[0];
                this.countryList = responseList[1];
                if(this.countryList?.length){
                    this.countryList?.sort(function(a, b) {
                        var textA = a?.countryName.toUpperCase();
                        var textB = b?.countryName.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    });
                }
               
                this.regulatorList = responseList[2];
                this.regulatorList?.sort(function(a, b) {
                    var textA = a?.regulatoryAuthority.toUpperCase();
                    var textB = b?.regulatoryAuthority.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
            }
        })
    }
    createfilterForm() {
        this.filterForm = new FormGroup({
            companyName: new FormControl(null),
            country: new FormControl(null),
            regulator: new FormControl(null),
            receiver: new FormControl(null),
        }, CustomValidation.formNotNull);
    }

    openAddInsurance() {
        this.addInsurance = true;

    }
    selectedValue(event: any, formElem: string) {
        if (!event) {
            this.filterForm.controls[formElem].patchValue(null);
        }
        this.filterForm.controls[formElem].patchValue(event);
    }
    applyFilter() {

            this.toasterandLoader.isLoaderEnable(true);
            let payLoad = {
                per_page: this.page_limit,
                page: this.page_no,
                sort: this.sortParams,
                TPACompanyName: this.filterForm?.value?.companyName ? this.filterForm?.value?.companyName : '',
                country: this.filterForm?.value?.country ? this.filterForm?.value?.country : '',
                regulator: this.filterForm?.value?.regulator ? this.filterForm?.value?.regulator : '',
                payerCode: this.filterForm?.value?.receiver ? this.filterForm?.value?.receiver : '',
            }
    
            if (this.user?.userDetails?.userType === USER_TYPE.payer && this.checkPermission('getPayerAccount')) {
                let id = this.user?.userDetails?.payerId as number
                this.provPayerApiService.getInsuranceListByPayer(id , payLoad).subscribe({
                    next: (response) => {
                        if (response) {
                            this.insuranceList = response?.data?.data;
                            this.totalCount = response?.data?.total;
                            if (!this.insuranceList.length) this.showNavigation = true;
                            this.toasterandLoader.isLoaderEnable(false);
                        }
                    },
                    error: (error) => {
                        this.toasterandLoader.isLoaderEnable(false);
                    },
                })
            } else if(this.checkPermission('getPayer')) {
                this.provPayerApiService.getInsuranceList(payLoad).subscribe({
                    next: (response) => {
                        if (response) {
                            this.insuranceList = response?.data?.data;
                            this.totalCount = response?.data?.total;
                            if (!this.insuranceList.length) this.showNavigation = true;
                            this.toasterandLoader.isLoaderEnable(false);
                        }
                    },
                    error: (error) => {
                        this.toasterandLoader.isLoaderEnable(false);
                    },
                })
            }


    }
    sortColumn(colName: string) {

        for (const key in this.columnSort) {
            if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
                const element = this.columnSort[key];
                if (key == colName) {
                    this.columnSort[colName].clicked = true;
                    this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
                    this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
                    this.applyFilter();
                }else{
                    this.columnSort[key].sortType = 'ascending';
                }

            }
        }
    }
    resetForm() {
        this.filterForm.reset();
        this.page_limit = 10;
        this.page_no = 1;
        this.totalCount=1;
        this.showNavigation = false;
        this.applyFilter();
        
    }
    currentPageDetail(event: any) {
        if (event) {
            this.page_no = event.button_no;
            this.page_limit = event.item_per_page;
        }
        this.focus.emit(true);
        this.applyFilter();

    }
    filterOnClick() {
        this.page_no = 1;
        this.applyFilter();
    }
    showEditPayerPopup(payerId: number | null) {
        this.editPayerId = payerId;
        this.showDetailView = false;
        this.addInsurance = true;
    }
    showPayerDetailsPopup(payerId: number | null) {
        this.editPayerId = payerId;
        this.showDetailView = true;
        this.isViewPayer = true;
    }
    manageEdit() {
        this.addInsurance = true;
        this.isViewPayer = false;
    }
    closePopup() {
        this.filterForm.reset();
        this.applyFilter();
    }

    checkPermission(perName:string):boolean{
        return this.userService.getPermissions(perName);
      }
    
}
